import React, { Component, Dispatch } from 'react';
import { Common } from '../../core/common';
import { IHomePageBoxMessagesProps } from '../../models/components/homepage-box-messages';
import { IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { Redirect } from 'react-router-dom';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import { SecureImage } from '../../components/core/secureImage';
import { Right } from 'react-bootstrap/lib/Media';
import Moment from 'moment';
import { Guid } from 'guid-typescript';
import * as Actions from '../../store/actions/profile';
import { IProfileProps } from '../../models/pages/profile';
import ContentLoader from 'react-content-loader';
import * as MessagePageActions from '../../store/actions/messages';
import { IPreference } from '../../models/action/profile';
import ShowAllButton from '../show-all-button/main';
import Truncater from '../truncater/main';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
export class CMessages extends Component<IHomePageBoxMessagesProps & IProfileProps> {
    state = {
        redirect: false,
        redirectUrl: '/',
        personalMessages: [],
        groupMessages: [],
        isSelectedPersonalMessagesTab: true,
        imageKey: Guid.create().toString(),
        boxItems: ['0', '1', '2', '3', '4', '5'],
        boxItemsVisual: [false, false, false, false, false, false],
        boxCount: 0
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public handleChange = () => {
        if (this.props.userPreferences) {
            this.props.userPreferences.forEach(preference => {
                if (preference.name === 'home.index.boxallowed') {
                    if (preference.value) {
                        this.state.boxItems = preference.value.split(',');
                        const index = this.state.boxItems.indexOf('3');
                        if (index !== -1) {
                            this.state.boxItems.splice(index, 1);
                        }
                        this.state.boxItems.forEach(item => {
                            this.state.boxItemsVisual[parseInt(item, 10)] = true;
                        });
                    }
                }
            });
            let preferenceData;
            const teacherPreferencesName = this.props.userPreferences[1].name;
            const studentPreferencesName = this.props.userPreferences[0].name;
            const preferencesValue = this.state.boxItems.toString();

            {
                teacherPreferencesName === 'home.index.boxallowed' ?
                    (preferenceData = {
                        preferences:
                            [{ name: teacherPreferencesName, value: preferencesValue }]
                    })
                    : (preferenceData = {
                        preferences:
                            [{ name: studentPreferencesName, value: preferencesValue }]
                    });
            }
            this.props.dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
        }
    }
    getImageUrl = (images: any) => {
        if (images && typeof images === 'string') {
            return images;
        } else if (images && typeof images === 'object') {
            return images[0];
        }
    };

    public async onMessageClick(messageId: string, userId: string, recipientName: string, images: any) {

        await this.triggerMessageModal().then(() => {
            this.props.dispatch(
                MessagePageActions.getMessageListAction({
                    skip: 0,
                    take: 9,
                    originMessageId: messageId,
                    contextType: 0,
                    contextId: userId, // TODO: buraya bir bakmak lazım...
                    imageUrl: this.getImageUrl(images),
                    chatTitleText: recipientName,
                    spinnerId: 'getMessageListAction',
                    spinnerType: 'get'
                })
            );
        });
    }

    public async triggerMessageModal() {
        this.props.triggerMessageModal();
    }

    onClickNavigateUrl = (messageId?: string, tabIndex?: number) => (event: any) => {
        let url = 'u/Message/Index';
        if (messageId && tabIndex) {
            url = url + '?messageId=' + messageId + '&tabIndex=' + tabIndex;
        }
        this.setState({ redirect: true, redirectUrl: url });
    }

    componentDidUpdate(prevProps: any) {
        const thisMessages = this.props.messages;
        const prevMessages = prevProps.messages;
        if (thisMessages !== prevMessages) {
            this.setState({ personalMessages: thisMessages!.conversations.filter((message: any) => !message.isGroup) });
            this.setState({ groupMessages: thisMessages!.conversations.filter((message: any) => message.isGroup) });
        }

    }

    changeTab = () => {
        this.setState({ imageKey: Guid.create().toString(), isSelectedPersonalMessagesTab: !this.state.isSelectedPersonalMessagesTab });
    }

    componentDidMount() {
        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount') as IPreference).value
                });
            }
        }
    }

    returnLastMessageText = (lastMessage: string) => {
        let messageText = "";

        if(lastMessage){
            const doc = new DOMParser().parseFromString(lastMessage, 'text/html');
            let textContent = doc.body.textContent ?? "";
            if(textContent){
                if(textContent.length > 120){
                    messageText = textContent.slice(0, 120) + ' ...';
                }else{
                    messageText = textContent;
                }
            }

        }

        return messageText;
    }

    public render() {
        const initialFormValues = {
            ...this.props.profileData,
            userPreferences: this.props.userPreferences,
            handleChange: this.handleChange
        };
        const loadingSpaces = 54;
        const loadingSizes = this.state.boxCount === 2 ? '0 0 540 300' : '0 0 350 300';
        const loadingWidth = this.state.boxCount === 2 ? 540 : 350;

        if (this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }

        return (
            <div className="white-box shadow">
                <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <span className='lms-header-medium' tabIndex={0}>
                            {T.t('r_home_index_box_message')}
                            <span className='badge badge-pill badge-light py-1 px-2' style={{marginInlineStart: "0.5rem"}}  tabIndex={0}>{this.props.messages?.conversations && this.props.messages?.conversations.length > 0 ? this.props.messages.conversations.length : '0'}</span>
                        </span>
                    </div>
                    <div className="align-self-center">
                        <i
                            className="material-icons mr-2 align-middle"
                            onClick={this.handleChange}
                            style={{ cursor: 'pointer' }}
                        >
                            visibility
                        </i>
                        <ShowAllButton redirectUrl='/u/Message/Index'/>
                    </div>
                </div>
                <Loading spinnerId={'getHomeBoxMessages'}>
                    <div style={{ backgroundColor: '#fbfaf6' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox={loadingSizes}
                            style={{ width: '100%' }}
                        >
                            <rect x="70" y="24" rx="3" ry="3" width="100" height="8" />
                            <rect x="70" y="44" rx="3" ry="3" width="150" height="7" />
                            <circle cx="35" cy="37" r="21" />
                            <rect x={loadingWidth - (96 + 17)} y="24" rx="3" ry="3" width="96" height="7" />

                            <rect x="70" y={24 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="100" height="8" />
                            <rect x="70" y={44 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="150" height="7" />
                            <circle cx="35" cy={37 + loadingSpaces} r="21" />
                            <rect x={loadingWidth - (96 + 17)} y={24 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="96" height="7" />

                            <rect x="70" y={24 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="100" height="8" />
                            <rect x="70" y={44 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="150" height="7" />
                            <circle cx="35" cy={37 + loadingSpaces * 2} r="21" />
                            <rect x={loadingWidth - (96 + 17)} y={24 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="96" height="7" />

                            <rect x="70" y={24 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="100" height="8" />
                            <rect x="70" y={44 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="150" height="7" />
                            <circle cx="35" cy={37 + loadingSpaces * 3} r="21" />
                            <rect x={loadingWidth - (96 + 17)} y={24 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="96" height="7" />

                            <rect x="70" y={24 + loadingSpaces * 4} rx="3" ry={3 + loadingSpaces * 4} width="100" height="8" />
                            <rect x="70" y={44 + loadingSpaces * 4} rx="3" ry={3 + loadingSpaces * 4} width="150" height="7" />
                            <circle cx="35" cy={37 + loadingSpaces * 4} r="21" />
                            <rect x={loadingWidth - (96 + 17)} y={24 + loadingSpaces * 4} rx="3" ry={3 + loadingSpaces * 4} width="96" height="7" />
                        </ContentLoader>
                    </div>
                </Loading>
                <ul id="getHomeBoxMessages_Content" className="white-box-body list-unstyled message-box">
                    {this.props.messages && this.props.messages.conversations.length > 0 ? (
                        (this.props.messages.conversations.filter((message: any) => !message.isGroup)).map((message: any, key) => {
                            return (
                                <li className="media mb-3" onClick={this.onMessageClick.bind(this, message.originMessageId, message.userId, message.recipientName, message.images)} key={key}>
                                    <div className="mt-0 homebox-clickable-item" tabIndex={0}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            this.onMessageClick(message.originMessageId, message.userId, message.recipientName, message.images)
                                        }
                                    }}
                                    >
                                        {message.images ? (
                                            /* tslint:disable-next-line */
                                            <SecureImage key={this.state.imageKey} style={{ borderRadius: 100, width: 24!, height: 24!, }} class={'chatting-single-user mr-3-x'} imageUrl={message.images[0]} />
                                        ) : ''}
                                    </div>
                                    <div className="media-body">

                                        <div className="d-inline-block w-100">

                                            <div className="message-intro">
                                                <div className="d-flex justify-content-between align-self-center">
                                                    <h5 className={ (!_common.isArabic(message.recipientName) ? 'left-text mt-0 homebox-clickable-item' : 'mt-0 homebox-clickable-item')} style={{width: "100%"}} tabIndex={0}
                                                    onKeyDown={event => {
                                                                    if (event.key === 'Enter') {
                                                                        this.onMessageClick(message.originMessageId, message.userId, message.recipientName, message.images)
                                                                    }
                                                                }}><Truncater text={message.recipientName}length={48} ></Truncater></h5>
                                                </div>
                                            </div>
                                            {
                                                <>
                                                    <div className="mt-0 homebox-clickable-item no-underline d-flex pt-1" tabIndex={0}>
                                                        <span  style={{ lineHeight: 1.145, width: "100%", textAlign: (_common.isArabic(this.returnLastMessageText(message.lastMessage)))? 'left': 'right'  }} dangerouslySetInnerHTML={{ __html: this.returnLastMessageText(message.lastMessage) }} />
                                                    </div>
                                                    <div className={ (!_common.isArabic(message.recipientName) ? 'left-text mt-1' : 'mt-1')}>
                                                        <i tabIndex={0}>{Moment(message.lastMessageDate).format(_common.findDateFormat(this.props.userPreferences!, true))}</i>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                        {/* Daha sonradan açılacak <span className="message-counter">{message.messageRead.length}</span> */}
                                    </div>
                                </li>
                            );
                        })
                    ) : (
                        <p tabIndex={0}>{T.t('r_home_box_message_not_found')}</p>
                    )}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxMessagesProps): IHomePageBoxMessagesProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IHomePageBoxMessagesProps = Object.assign({}, ownProps, {
        messages: state.coursePage.myMessages,
        userPreferences: state.profile.userPreferences.preferences
    });
    return newProps;
};

// const areStatesEqual = (next: IAppState, prev: IAppState) => {
//     const ret = (
//         next.coursePage.myMessages === prev.coursePage.myMessages
//     );
//     return ret;
// };

const Messages = connect(mapStateToProps,)(CMessages);

export default Messages;
